import type { MaybeRef } from "vue";
import { computed } from "vue";
import { useCurrentTodo } from "@/composables/useCurrentTodo";
import { hasTiptapText } from "@/util/tiptap";

type TodoInstructions = Record<string, unknown> | undefined;

export const useTodoInstructions = (todoId: MaybeRef<string>, applicationId: MaybeRef<string | undefined>) => {
  const { todo, isLoading } = useCurrentTodo(todoId, applicationId);

  const instructions = computed<TodoInstructions>(() => {
    const found = todo.value?.instructions;
    return hasTiptapText(found) ? found : undefined;
  });

  return { instructions, isLoading };
};
